/**
 * Created by Ning Jiang on 5/17/2017.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IMultiSpritesConfig, MultiSprites} from "@nolimitcity/slot-game/bin/core/displayobject/MultiSprites";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {TimelineLite, TweenLite} from "gsap";
import {IWixxGameModeChangedData} from "../../gamemode/WixxGameMode";
import {WixxParsedGameData} from "../../server/data/WixxParsedGameData";
import {WixxGameConfig} from "../../WixxGameConfig";

export class WinWaysWonIndicator extends BaseView {

    public static readonly SHOW_WIN_WAYS_WON:string = "winWaysWonIndicatorEvent_showWinWaysWon";

    private static readonly TEXT_WAYS_WON:string = "WAYS_WON";
    private static readonly TEXT_WAY_WON:string = "WAY_WON";

    private static readonly WIN_WAYS_TEXT_FADE_IN_DURATION:number = 0.5;
    private static readonly WIN_WAYS_NUMBER_FADE_IN_DELAY:number = 0.3;
    private static readonly WIN_WAYS_NUMBER_FADE_IN_DURATION:number = 0.5;
    private static readonly HIDE_DELAY:number = 0.8;
    private static readonly MOBILE_OFFSET_Y:number = -135;

    public static readonly FEATURE_COLORS = {
        BASE : "#93011b",
        RED_BOOSTER : "#9e1a1a",
        YELLOW_BOOSTER : "#a57216",
        BLUE_BOOSTER : "#144fa7",
        RED_YELLOW_BOOSTER : "#9e1a1a",
        RED_BLUE_BOOSTER : "#144fa7",
        YELLOW_BLUE_BOOSTER : "#a57216"
    };

    private static readonly FEATURE_81WAYS_IMAGES = {
        BASE : "81ways_base",
        RED_BOOSTER : "81ways_red",
        YELLOW_BOOSTER : "81ways_yellow",
        BLUE_BOOSTER : "81ways_blue",
        RED_YELLOW_BOOSTER : "81ways_red",
        RED_BLUE_BOOSTER : "81ways_blue",
        YELLOW_BLUE_BOOSTER : "81ways_yellow"
    };

    public static readonly FEATURE_TEXT_IMAGES = {
        WAY_WON : {
            BASE : "waywon_base",
            RED_BOOSTER : "waywon_red",
            YELLOW_BOOSTER : "waywon_yellow",
            BLUE_BOOSTER : "waywon_blue",
            RED_YELLOW_BOOSTER : "waywon_red",
            RED_BLUE_BOOSTER : "waywon_blue",
            YELLOW_BLUE_BOOSTER : "waywon_yellow"
        },
        WAYS_WON : {
            BASE : "wayswon_base",
            RED_BOOSTER : "wayswon_red",
            YELLOW_BOOSTER : "wayswon_yellow",
            BLUE_BOOSTER : "wayswon_blue",
            RED_YELLOW_BOOSTER : "wayswon_red",
            RED_BLUE_BOOSTER : "wayswon_blue",
            YELLOW_BLUE_BOOSTER : "wayswon_yellow"
        }
    };

    private static readonly NUMBER_STYLE:TextStyleOptions = {
        fontFamily : "Open Sans Condensed light",
        fontSize : 55,
        fill : "#93011b",
        align : "center"
    };

    private _landScapeLayer:PIXI.Container;
    private _portraitLayer:PIXI.Container;
    private _waysWonNumber:PIXI.Container;
    private _waysWonNumberText:PIXI.Text;
    private _waysWonNumberTextInvisible:PIXI.Text;
    private _waysWonText:MultiSprites;
    private _81waysText:MultiSprites;

    private _showTimeline:TimelineLite;
    private _waysWonHeight:number = 69;

    private _winWaysTotal:number;
    private _currentWinText:string;
    private _currentFeature:string;

    constructor() {
        super();
        this._landScapeLayer = StageManager.getLayer(WixxGameConfig.instance.LAYERS.LANDSCAPE_WIN_WAYS.name);
        this._portraitLayer = StageManager.getLayer(WixxGameConfig.instance.LAYERS.PORTRAIT_WIN_WAYS.name);
        this._currentFeature = "BASE";
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, WinWaysWonIndicator.SHOW_WIN_WAYS_WON, (event:GameEvent) => this.onShowWinWaysWon(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onHideWinWaysWon());
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event:GameEvent) => this.onGameModeChange(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data:WixxParsedGameData):void {
        this._winWaysTotal = 0;
        for(let i:number = 0; i < data.betWins.length; i++) {
            const betWayWin:IBetWayWinData = <IBetWayWinData>data.betWins[i];
            this._winWaysTotal += betWayWin.numberOfCombinations;
        }
    }

    protected initAnimations():void {
        this._waysWonNumber = new PIXI.Container();
        this._waysWonNumber.alpha = 0;

        this._waysWonNumberText = new PIXI.Text("", WinWaysWonIndicator.NUMBER_STYLE);
        this._waysWonNumberText.anchor.set(0.5, 0.5);
        this._waysWonNumber.addChild(this._waysWonNumberText);

        // for different color text to fade in/out when switching features.
        this._waysWonNumberTextInvisible = new PIXI.Text("", WinWaysWonIndicator.NUMBER_STYLE);
        this._waysWonNumberTextInvisible.anchor.set(0.5, 0.5);
        this._waysWonNumberTextInvisible.alpha = 0;
        this._waysWonNumber.addChild(this._waysWonNumberTextInvisible);

        const textConfig:IMultiSpritesConfig = {};
        for(let textName in WinWaysWonIndicator.FEATURE_TEXT_IMAGES) {
            for(let featureName in (<any>WinWaysWonIndicator.FEATURE_TEXT_IMAGES)[textName]) {
                textConfig[`${textName}_${featureName}`] = {
                    textures : GameResources.getTextures((<any>WinWaysWonIndicator.FEATURE_TEXT_IMAGES)[textName][featureName]),
                    anchor : [0.5, 0.5]
                }
            }
        }
        this._waysWonText = new MultiSprites(textConfig);
        this._waysWonText.visible = false;


        const text81Config:IMultiSpritesConfig = {};
        for(let featureName in WinWaysWonIndicator.FEATURE_81WAYS_IMAGES) {
            text81Config[featureName] = {
                textures : GameResources.getTextures((<any>WinWaysWonIndicator.FEATURE_81WAYS_IMAGES)[featureName]),
                anchor : [0.5, 0.5]
            }
        }
        this._81waysText = new MultiSprites(text81Config);
        if(UserAgent.isMobile) {
            this._81waysText.position.set(140, 307 + WinWaysWonIndicator.MOBILE_OFFSET_Y);
        } else {
            this._81waysText.position.set(140, 307);
        }
        this._81waysText.playSprite(this._currentFeature, {duration : 0, vars : [{toVars : {alpha : 1}}]});
        this._landScapeLayer.addChild(this._81waysText);
    }

    private onShowWinWaysWon(winWaysWon?:number, animate?:boolean):void {
        winWaysWon = winWaysWon != undefined ? winWaysWon : this._winWaysTotal;
        animate = animate != undefined ? animate : true;

        this._currentWinText = winWaysWon === 1 ? WinWaysWonIndicator.TEXT_WAY_WON : WinWaysWonIndicator.TEXT_WAYS_WON;

        const timeline:TimelineLite = new TimelineLite({paused : true});

        let numberDelay:number = 0;
        if(!this._waysWonText.visible) {
            timeline.add([
                () => {this._waysWonText.visible = true;},
                this._waysWonText.playSprite(
                    `${this._currentWinText}_${this._currentFeature}`,
                    {
                        duration : animate ? WinWaysWonIndicator.WIN_WAYS_TEXT_FADE_IN_DURATION : 0,
                        vars : [{fromVars : {alpha : 0}, toVars : {alpha : 1}}]
                    })
            ], 0);
            numberDelay = animate ? WinWaysWonIndicator.WIN_WAYS_NUMBER_FADE_IN_DELAY : 0;
        } else {
            timeline.add(this._waysWonText.playSprite(
                `${this._currentWinText}_${this._currentFeature}`,
                {
                    duration : 0,
                    vars : [{toVars : {alpha : 1}}]
                }), 0);
        }

        timeline.add([
            TweenLite.fromTo(this._waysWonNumber, animate ? WinWaysWonIndicator.WIN_WAYS_NUMBER_FADE_IN_DURATION : 0, {alpha : 0}, {alpha : 1}),
            () => {
                this._waysWonNumberText.style.fill = (<any>WinWaysWonIndicator.FEATURE_COLORS)[this._currentFeature];
                this._waysWonNumberText.text = "" + winWaysWon;
                this._waysWonNumberTextInvisible.text = "" + winWaysWon;
            }
        ], numberDelay);

        this._showTimeline = timeline;
        this._showTimeline.play();
    }

    private onHideWinWaysWon():void {
        if(this._winWaysTotal > 0) {
            if(this._showTimeline && this._showTimeline.isActive()) {
                this._showTimeline.progress(1);
            }
            this.onShowWinWaysWon(this._winWaysTotal, false);

            const timeline:TimelineLite = new TimelineLite();
            timeline.add([
                TweenLite.to(this._waysWonNumber, 0.2, {alpha : 0}),
                this._waysWonText.playSprite(
                    `${this._currentWinText}_${this._currentFeature}`,
                    {
                        duration : 0.2,
                        vars : [{toVars : {alpha : 0}}]
                    })
            ], WinWaysWonIndicator.HIDE_DELAY);
            timeline.add(() => {
                this._waysWonText.visible = false;
            });
        }
    }

    private onGameModeChange(newMode:IWixxGameModeChangedData) {
        if(newMode.feature == null) {
            return;
        }

        if(newMode.feature === this._currentFeature) {
            return;
        }

        this._currentFeature = newMode.feature;
        const featureColor = (<any>WinWaysWonIndicator.FEATURE_COLORS)[newMode.feature];
        const timeline:TimelineLite = new TimelineLite({paused : true});
        timeline.add(this._81waysText.playSprite(
            this._currentFeature,
            {
                duration : WixxGameConfig.instance.GAME_FEATURE_CHANGE_ANIMATION_DURATION,
                vars : [{fromVars : {alpha : 0}, toVars : {alpha : 1}}]
            },
            {
                duration : WixxGameConfig.instance.GAME_FEATURE_CHANGE_ANIMATION_DURATION,
                vars : [{toVars : {alpha : 0}}]
            }
        ), 0);

        if(this._waysWonText.visible) {
            let a = this._waysWonNumberTextInvisible;
            this._waysWonNumberTextInvisible = this._waysWonNumberText;
            this._waysWonNumberText = a;
            this._waysWonNumberText.style.fill = featureColor;


            timeline.add([
                this._waysWonText.playSprite(
                    `${this._currentWinText}_${this._currentFeature}`,
                    {
                        duration : WixxGameConfig.instance.GAME_FEATURE_CHANGE_ANIMATION_DURATION,
                        vars : [{fromVars : {alpha : 0}, toVars : {alpha : 1}}]
                    },
                    {
                        duration : WixxGameConfig.instance.GAME_FEATURE_CHANGE_ANIMATION_DURATION,
                        vars : [{toVars : {alpha : 0}}]
                    },
                ),
                TweenLite.to(this._waysWonNumberText, WixxGameConfig.instance.GAME_FEATURE_CHANGE_ANIMATION_DURATION, {alpha : 1}),
                TweenLite.to(this._waysWonNumberTextInvisible, WixxGameConfig.instance.GAME_FEATURE_CHANGE_ANIMATION_DURATION, {alpha : 0})
            ], 0);
        }

        timeline.play();
    }

    protected onResize(data:IResizeData):void {
        if(data.orientation === Orientation.PORTRAIT) {
            //show ways won on top of the reel for portrait mode on mobile only.
            this._portraitLayer.addChild(this._waysWonNumber);
            this._portraitLayer.addChild(this._waysWonText);
            const topHeight:number = Math.min(200, this._portraitLayer.y / this._portraitLayer.scale.y);
            const y:number = -topHeight / 2;
            let scale:number;
            if(topHeight >= this._waysWonHeight * 2) {
                scale = topHeight / 2 / this._waysWonHeight;
            } else if(topHeight >= this._waysWonHeight) {
                scale = 1;
            } else {
                scale = topHeight / this._waysWonHeight;
            }

            this._waysWonText.position.set(GameConfig.instance.REEL_DISPLAY_POSITIONS[2][0] + WixxGameConfig.instance.REEL_AREA_POS_X, y);
            this._waysWonText.scale.set(scale, scale);
            this._waysWonNumber.position.set(GameConfig.instance.REEL_DISPLAY_POSITIONS[1][0] + WixxGameConfig.instance.REEL_AREA_POS_X, y);
            this._waysWonNumber.scale.set(scale, scale);
        } else {
            this._landScapeLayer.addChild(this._waysWonNumber);
            this._landScapeLayer.addChild(this._waysWonText);
            this._waysWonText.scale.set(1, 1);
            this._waysWonNumber.scale.set(1, 1);

            if(UserAgent.isMobile) {
                this._waysWonText.position.set(1147, 343 + WinWaysWonIndicator.MOBILE_OFFSET_Y);
                this._waysWonNumber.position.set(1147, 265 + WinWaysWonIndicator.MOBILE_OFFSET_Y);
            } else {
                this._waysWonText.position.set(1147, 343);
                this._waysWonNumber.position.set(1147, 265);
            }
        }
    }
}